import type { Certainty, ItemResult } from '../domain/items';
import type { Project } from '../domain/project';
export const certaintyLabel:Record<Certainty,string>={confirmed_amount:'금액 확정',included:'포함',excluded_amount:'별도 금액',conditional:'조건부',missing:'안 적힘',unreadable:'다시 확인'};
/** 저장 상태는 유지하고, 원문이 있는 미확정 항목을 빈칸으로 표시하지 않는다. */
export function itemStatusLabel(item:ItemResult){
 if(item.amountKrw===null&&((item.certainty==='missing'&&/별도/.test(item.sourceText??''))||item.certainty==='excluded_amount'))return '별도 · 금액 미정';
 if(item.certainty==='confirmed_amount'&&item.amountKrw===null)return '금액 미정';
 if(item.certainty==='missing'&&item.sourceText?.trim())return '내용 확인 필요';
 return certaintyLabel[item.certainty];
}
export function responseUpdateLabel(response:Project['responses'][number],project:Project){
 if(!response.updatedAt||response.updatedAt===response.createdAt)return '';
 // 이전 반영 코드가 연결 시각을 updatedAt에 쓴 기록도 내용 수정으로 단정하지 않는다.
 return project.agreementChanges.some(change=>change.createdAt===response.updatedAt&&change.itemId===response.itemId&&change.sourceExcerpt===response.text)?'항목에 연결함':'고침';
}
export const projectUndoSnapshots=new Map<string,Project>();
